import fetch from 'auth/FetchInterceptor'

const empresaService = {}

empresaService.get = function () {
  return fetch({
    url: '/empresa',
    method: 'get',
    headers: {
        'Content-Type': 'application/json',
      },
  })
}

empresaService.cancelar = function (data) {
  return fetch({
    url: `/boleto/${data}/cancelar`,
    method: 'delete',
    data: data
  })
}

empresaService.reenviar = function (data) {
  return fetch({
    url: `/boleto/${data}/reenviar`,
    method: 'post',
    data: data
  })
}

empresaService.getPlano = function () {
  return fetch({
    url: '/plano',
    method: 'get',
    headers: {
        'Content-Type': 'application/json',
      },
  })
}

empresaService.getModulos = function () {
  return fetch({
    url: '/modulo',
    method: 'get',
    headers: {
        'Content-Type': 'application/json',
      },
  })
}

empresaService.atualizarModulos = function (data) {
  return fetch({
    url: `/empresa/modulo`,
    method: 'post',
    data: data
  })
}

empresaService.atualizarPlano = function (data) {
  return fetch({
    url: `/empresa/plano/${data}`,
    method: 'put',
    data: data
  })
}

empresaService.salvarConfiguracao = function (data) {
  return fetch({
    url: '/empresa/configuracao',
    method: 'put',
    data: data
  })
}

empresaService.salvarGateway = function (data) {
  return fetch({
    url: '/empresa/gateway',
    method: 'put',
    data: data
  })
}

empresaService.salvarTimezone = function (data) {
  return fetch({
    url: '/empresa/timezone',
    method: 'put',
    data: data
  })
}

empresaService.salvarGatewayCora = function ({ clientId, senha, certificado }) {
  const formData = new FormData()
  formData.append('clientId', clientId)
  formData.append('senha', senha)
  formData.append('certificado', certificado)
  return fetch({
    url: '/empresa/gateway/cora',
    method: 'put',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

empresaService.getAutentique = function () {
  return fetch({
    url: '/empresa/autentique',
    method: 'get',
  })
}

empresaService.salvarAutentique = function (data) {
  return fetch({
    url: '/empresa/autentique',
    method: 'put',
    data: data,
  })
}

empresaService.getTokenCadastroPublico = function () {
  return fetch({
    url: '/empresa/cadastro-publico/token',
    method: 'get',
  })
}

empresaService.gerarTokenCadastroPublico = function () {
  return fetch({
    url: '/empresa/cadastro-publico/token',
    method: 'post',
  })
}

export default empresaService